import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingPrintingTemplate  {
    _originalTypeClassName = "zERP.BO.AccountingPrintingTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingPrintingTemplate.translate = translateService;
}
this.Entity = new Domain.AccountingBusinessEntity();
this.Id = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Template:any;
Entity:any;
FiscalPeriod:any;
static setTemplate = ($this, value) => {
var oldValue = $this.Template;
$this.Template = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}

static ExecuteSimpleAdd($this: any, parsedFunction: any): any{let tempResult = 0;
let parsedValue = 0;
for (let _iarg = 0; _iarg < (parsedFunction?.Arguments == null ? 0 : parsedFunction?.Arguments.length); _iarg++) {let arg = parsedFunction?.Arguments[_iarg];if ((Joove.Common.stringContains(arg?.Value, "|"))) {let splittedList = System.split(arg?.Value, '|');for (let _ivalue = 0; _ivalue < (splittedList == null ? 0 : splittedList.length); _ivalue++) {let value = splittedList[_ivalue];parsedValue = CLMS.Framework.Decimal.Parse(value);tempResult = Joove.Common.safeNumber(tempResult) + Joove.Common.safeNumber(parsedValue);}}else {parsedValue = CLMS.Framework.Decimal.Parse(arg?.Value);tempResult = Joove.Common.safeNumber(tempResult) * Joove.Common.safeNumber(parsedValue);}}
return tempResult?.toString();
}
static GetAllFunctions(): any{let vars = [];
vars?.add(Domain.PrintingVariableInfo.CreateVariable("GET_BALANCE", "Retrieves this year's balance of one or many account.", "List[Accounts]"));
vars?.add(Domain.PrintingVariableInfo.CreateVariable("PREV_BALANCE", "Retrieves last year's balance of one or many  account.", "List[Accounts]"));
return vars;
}
static GetAllVariables($this: any): any{let vars = new window['Map']();
vars.set("CURRENT_YEAR", Domain.PrintingVariableInfo.CreateVariable(Joove.Common.safeNumber(moment($this?.FiscalPeriod?.StartDate).year()) + "", "The current fiscal year.", null));
vars.set("FISCAL_YEAR_INDEX", Domain.PrintingVariableInfo.CreateVariable("12", "Years of company's existence.", null));
vars.set("ENTITY_NAME", Domain.PrintingVariableInfo.CreateVariable($this?.Entity?.Name, "The company's name.", null));
vars.set("ENTITY_ADDRESS", Domain.PrintingVariableInfo.CreateVariable($this?.Entity?.AddressLine, "The company's address information.", null));
vars.set("ENTITY_AFM", Domain.PrintingVariableInfo.CreateVariable($this?.Entity?.AFM, "The company's tax identification number.", null));
vars.set("ENTITY_DOY", Domain.PrintingVariableInfo.CreateVariable($this?.Entity?.DOY, "The company's assigned tax office.", null));
vars.set("PRINT_DATE", Domain.PrintingVariableInfo.CreateVariable(CLMS.Framework.DateTime.ToString(moment().toDate(), "dd/MM/yyyy"), "Today's date as dd/MM/yyyy", null));
return vars;
}
static SetupAllVariables($this: any): any{let varsDict = Domain.AccountingPrintingTemplate.GetAllVariables($this);
let vars = [];
for (let _ivariableName = 0; _ivariableName < (Array['from'](varsDict.keys()) == null ? 0 : Array['from'](varsDict.keys()).length); _ivariableName++) {let variableName = Array['from'](varsDict.keys())[_ivariableName];let variable = new Domain.PrintingVariableInfo();variable.Value = variableName;variable.Description = varsDict.get(variableName)?.Description;vars?.add(variable);}
return vars;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}